// src/pages/TransactionPage.js
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useAuth } from '../context/AuthContext';

// UBAH: gunakan core & scoped modules yang sama
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { CsvExportModule } from '@ag-grid-community/csv-export';

// Styles
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';


// Register modules
ModuleRegistry.registerModules([ClientSideRowModelModule, CsvExportModule]);

// Fungsi untuk membuat daftar bulan
const generateMonthOptions = () => {
//  const options = [];
//  const d = new Date();
//  for (let i = 0; i < 12; i++) {
//    const month = d.toISOString().slice(0, 7);
//    const label = d.toLocaleString('default', { month: 'long', year: 'numeric' });
//    options.push({ value: month, label: label });
//    d.setMonth(d.getMonth() - 1);
//  }
//  return options;

// Edited by Kopp
   const options = [];
   const d = new Date();
   for (let i = 0; i < 12; i++) {
     const year = d.getFullYear();
     const month = String(d.getMonth() + 1).padStart(2, '0'); // 1–12 → "01"–"12"
     options.push({
       value: `${year}-${month}`,
       label: d.toLocaleString('default', { month: 'long', year: 'numeric' })
     });
     d.setMonth(d.getMonth() - 1);
   }
   return options;
};

const options = {
  timeZone: 'Asia/Jakarta',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

function formatDateToISO(date) {
  const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
  const [day, month, year] = formattedDate.split('/');
  return `${year}-${month}-${day}`;
}

// Custom cell renderer for currency to match SummaryTable format
const CurrencyCellRenderer = (params) => {
  if (params.value == null || isNaN(params.value)) return '';
  const formatted = new Intl.NumberFormat('id-ID').format(params.value);
  
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <span>Rp</span>
      <span>{formatted}</span>
    </div>
  );
};

const formatNumber = (params) => {
  if (params.value == null || isNaN(params.value)) return '';
  return new Intl.NumberFormat('id-ID').format(params.value);
};

function TransactionPage() {
  // UBAH: ref langsung ke komponen grid
  const gridRef = useRef(null);

  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [isGridReady, setIsGridReady] = useState(false);
  const [vendors, setVendors] = useState([]);
  const auth = useAuth();

//  const today = new Date().toISOString().slice(0, 10);
//  const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);

const getToday = new Date();
const getFirstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
const today = formatDateToISO(getToday);
const firstDayOfMonth = formatDateToISO(getFirstDayOfMonth);


 
  const [filterType, setFilterType] = useState('daily'); // 'daily' or 'monthly'
  const [selectedMonth, setSelectedMonth] = useState('');
  const monthOptions = generateMonthOptions();
  
  const [filters, setFilters] = useState({
    start_date: firstDayOfMonth,
    end_date: today,
    agent: '',
    transaction_type: 'Transaction',
    value_type: 'amount',
    vendor: ''
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = async () => {
    // UBAH: pakai gridRef.current?.api
    if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.showLoadingOverlay();
    }

    // Build filters based on filter type
    let finalFilters = { ...filters };
    
    // if (filterType === 'monthly' && selectedMonth) {
    //   // Convert month to start_date and end_date
    //   const [year, month] = selectedMonth.split('-');
    //   const startDate = new Date(year, month - 1, 1);
    //   const endDate = new Date(year, month, 0); // Last day of the month
      
    //   finalFilters.start_date = startDate.toISOString().slice(0, 10);
    //   finalFilters.end_date = endDate.toISOString().slice(0, 10);
    // }

    if (filterType === 'monthly' && selectedMonth) {
      // Convert month to start_date and end_date
      const [year, month] = selectedMonth.split('-');
      const startDate = new Date(year, month - 1, 1);
      const endDate = new Date(year, month, 0); // Last day of the month

      finalFilters.start_date = formatDateToISO(startDate);
      finalFilters.end_date = formatDateToISO(endDate);
    }


    const params = new URLSearchParams(finalFilters);
    const apiUrl = `/api/pivot_data?${params.toString()}`;

    try {
      const response = await auth.authFetch(apiUrl);
      const data = await response.json();

      if (data.columns && data.data) {
        const dynamicColumns = data.columns.map(col => {
          const isTotalCol = col === 'Total';
          let colDef = {
            field: col.toString(),
            headerName: col.toString().toUpperCase(),
          };

          if (col === 'pga') {
            colDef = { ...colDef, pinned: 'left', filter: true, width: 150 };
          } else if (col === 'vendor') {
            colDef = { ...colDef, pinned: 'left', filter: true, width: 120 };
          } else if (col === 'project') {
            colDef = { ...colDef, pinned: 'left', filter: true, width: 120 };
          } else if (col === 'Total') {
            colDef = {
              ...colDef,
              width: 180,
              cellRenderer: filters.value_type === 'amount' ? CurrencyCellRenderer : undefined,
              valueFormatter: filters.value_type === 'amount' ? undefined : formatNumber,
              cellStyle: filters.value_type === 'amount' 
                ? { fontWeight: 'bold', padding: '0 12px' }
                : { textAlign: 'right', fontWeight: 'bold' },
              pinned: 'left'
            };
          } else {
            colDef = {
              ...colDef,
              width: 150,
              cellRenderer: filters.value_type === 'amount' ? CurrencyCellRenderer : undefined,
              valueFormatter: filters.value_type === 'amount' ? undefined : formatNumber,
              cellStyle: filters.value_type === 'amount' 
                ? { padding: '0 12px' }
                : { textAlign: 'right' }
            };
          }

          // Total column handling moved above

          return colDef;
        });

        setColumnDefs(dynamicColumns);
        setRowData(data.data);
      } else {
        setColumnDefs([]);
        setRowData([]);
      }
    } catch (error) {
      console.error("Gagal mengambil data pivot:", error);
      setColumnDefs([]);
      setRowData([]);
    } finally {
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
    }
    }
  };

  // Fetch vendors when component mounts
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await auth.authFetch('/api/transaction-vendors');
        const data = await response.json();
        setVendors(data);
      } catch (error) {
        console.error("Gagal mengambil data vendor:", error);
      }
    };

    fetchVendors();
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onExportClick = () => {
    // UBAH: akses API via gridRef.current.api (bukan ref manual)
    const api = gridRef.current?.api;
    if (!api) {
      console.error("Grid API tidak tersedia saat mencoba ekspor.");
      return;
    }
    api.exportDataAsCsv({
      // opsional: beri nama file yang informatif
      fileName: `${filters.agent},${filters.vendor},${filters.transaction_type}_${filters.value_type}_${filters.start_date}_${filters.end_date}.csv`,
      suppressQuotes: true,
   processCellCallback: (params) => {
      // Jangan ubah kolom 'pga', 'vendor', 'project', dan 'Total'
      const rawValue = params.value;
      if (params.column.getColId() === 'pga' || params.column.getColId() === 'vendor' || params.column.getColId() === 'project' || params.column.getColId() === 'Total') {
        return rawValue;
      }

      // Hilangkan format 'Rp' dan separator ribuan
      if (typeof rawValue === 'string') {
        const cleaned = rawValue.replace(/Rp/g, '').replace(/\./g, '').replace(/,/g, '.').trim();
        return isNaN(cleaned) ? rawValue : cleaned;
      }

      return rawValue;
    }
  });
};

  // UBAH: gunakan callback; Strict Mode akan memanggil dua kali, tapi tidak merusak ref
  const onGridReady = useCallback(() => {
    setIsGridReady(true);
  }, []);

  // (Opsional, but nice): bila grid dihancurkan, tandai tidak ready
  const onGridPreDestroyed = useCallback(() => {
    setIsGridReady(false);
  }, []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }), []);

  const getRowStyle = params => {
    if (params.data?.pga === 'Total') {
      return { fontWeight: 'bold', backgroundColor: '#343a40', color: 'white' };
    }
  };

  const getRowId = params => {
    if (params.data?.pga === 'Total') return 'TotalRow';
    return (params.data?.pga ?? '') + (params.data?.vendor ?? '') + (params.data?.project ?? '');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <h1>Transaction Pivot</h1>

      <div className="pivot-filters" style={{ gap: 8, display: 'flex', flexWrap: 'wrap', marginBottom: 8, alignItems: 'center' }}>
        {/* Filter Type Selector */}
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <label>
            <input 
              type="radio" 
              value="daily" 
              checked={filterType === 'daily'} 
              onChange={(e) => setFilterType(e.target.value)}
            />
            {' '}Harian
          </label>
          <label>
            <input 
              type="radio" 
              value="monthly" 
              checked={filterType === 'monthly'} 
              onChange={(e) => setFilterType(e.target.value)}
            />
            {' '}Bulanan
          </label>
        </div>
        
        {/* Daily Filter */}
        {filterType === 'daily' && (
          <>
            <input type="date" name="start_date" value={filters.start_date} onChange={handleFilterChange} />
            <input type="date" name="end_date" value={filters.end_date} onChange={handleFilterChange} />
          </>
        )}
        
        {/* Monthly Filter */}
        {filterType === 'monthly' && (
          <select 
            value={selectedMonth} 
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            <option value="">Pilih Bulan</option>
            {monthOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        )}
        
        <select name="agent" value={filters.agent} onChange={handleFilterChange}>
          <option value="">All Agents</option>
          <option value="B2B">B2B</option>
          <option value="B2C">B2C</option>
        </select>
        <select name="vendor" value={filters.vendor} onChange={handleFilterChange}>
          <option value="">All Vendors</option>
          {vendors.map(vendor => (
            <option key={vendor} value={vendor}>{vendor}</option>
          ))}
        </select>
        <select name="transaction_type" value={filters.transaction_type} onChange={handleFilterChange}>
          <option value="Transaction">Transaction</option>
          <option value="Disbursement">Disbursement</option>
        </select>
        <select name="value_type" value={filters.value_type} onChange={handleFilterChange}>
          <option value="amount">Amount</option>
          <option value="entries">Entries</option>
        </select>
        <button onClick={applyFilters}>Apply Filter</button>
        <button onClick={onExportClick} disabled={!isGridReady || rowData.length === 0}>Export to CSV</button>
      </div>

      <div className="ag-theme-alpine" style={{ flex: 1, width: '100%' }}>
        <AgGridReact
          ref={gridRef}                         // UBAH: ref ke AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          getRowStyle={getRowStyle}
          getRowId={getRowId}
          onGridReady={onGridReady}
          onGridPreDestroyed={onGridPreDestroyed}
          // UBAH: overlay templates taruh di level grid, bukan defaultColDef
          overlayNoRowsTemplate="<span>No data found for the selected filters.</span>"
          overlayLoadingTemplate="<span>Loading...</span>"
        />
      </div>
    </div>
  );
}

export default TransactionPage;
